/* Mirrors the server-side OTP resend cooldown (60 s, see
 * apps/api/src/portal/auth/portal-otp.service.ts OTP_RESEND_COOLDOWN_MS) so the
 * UI can disable resend with an honest countdown instead of implying a new
 * code was sent while the challenge is still inside the cooldown window. */
import { useCallback, useEffect, useRef, useState } from 'react';

export const OTP_RESEND_COOLDOWN_MS = 60_000;

export function useResendCooldown() {
  const [availableAt, setAvailableAt] = useState<number | null>(null);
  const [now, setNow] = useState(() => Date.now());
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (availableAt == null || availableAt <= now) return undefined;
    timerRef.current = setInterval(() => setNow(Date.now()), 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [availableAt, now]);

  const secondsLeft = availableAt ? Math.max(0, Math.ceil((availableAt - now) / 1000)) : 0;
  const startCooldown = useCallback(() => {
    setNow(Date.now());
    setAvailableAt(Date.now() + OTP_RESEND_COOLDOWN_MS);
  }, []);

  return { secondsLeft, startCooldown };
}
